import { useQuery } from "@tanstack/react-query";
import axios from "axios";

// Function to fetch validate srf
export const fetchValidateSrf = async (clientId, projectId) => {
  try {
    const response = await axios.get(
      `/api/validate-srf/${clientId}/${projectId}/`,
      {
        withCredentials: true,
      },
    );

    return response.data;
  } catch (error) {
    console.log(error);
  }
};

// Custom hook to fetch validate srf
export default function useValidateSrf(clientId, projectId) {
  return useQuery({
    queryKey: ["validate-srf", clientId, projectId],
    queryFn: () => fetchValidateSrf(clientId, projectId),
    enabled: !!clientId && !!projectId,
  });
}
